import { Component } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';
import { Box } from 'components/common/box';

const PathDelete = connect((state) => state)(
  class extends Component {
    deletePath = async (values) => {
      const {
        pageState: { path }
      } = this.props;

      let url = `/admin/paths/${path.id}`;

      if (values?.deletionReason) {
        const params = new URLSearchParams({
          deletionReason: values.deletionReason
        });
        url += `?${params.toString()}`;
      }

      await api.delete(url);
      Router.push('/paths');
      return true;
    };

    render() {
      const {
        messages,
        serverConfig: { requireReasonWhenDeletingData }
      } = this.props;

      return (
        <div className="delete">
          <Box title={messages.commonDelete}>
            {requireReasonWhenDeletingData ? (
              <ConfirmDeleteButton
                buttonText={messages.pathsDelete}
                confirmText={messages.pathsDeleteConfirm}
                confirmTitle={messages.pathsDelete}
                id="deletionReasonPath"
                onConfirm={this.deletePath}
                successMessage={messages.pathsDeleteSuccess}
              />
            ) : (
              <ConfirmButton
                actionText={messages.commonDelete}
                buttonIcon="trash-alt"
                buttonText={messages.pathsDelete}
                category="danger"
                confirmText={messages.pathsDeleteConfirm}
                confirmTitle={messages.pathsDelete}
                onConfirm={this.deletePath}
                successMessage={messages.pathsDeleteSuccess}
              />
            )}
          </Box>
        </div>
      );
    }
  }
);

export default PathDelete;
